import clsx from 'clsx';
import React from 'react';

const Select = ({ className, ...props }) => (
  <select
    className={clsx(
      className,
      `w-full appearance-none block py-1.5 pr-10 px-2 text-gray-800 rounded text-left border-none shadow-input focus:shadow-input-focus`,
    )}
    {...props}
  />
);

export default Select;
